import axios from "axios";

const outpatientEndpoints = [
    "/consultationpatients",
    "/procedurepatients",
    "/dentalpatients",
    "/radiologypatients",
    "/antenatalpatients",
    "/maternitypatients",
    "/theaterpatients",
    "/otherpatients",
];

let outpatientCache = null;
let outpatientCacheFetchedAt = 0;
const outpatientCacheTtlMs = 2 * 60 * 1000;

function normalizeTreatment(record) {
    if (!record) {
        return null;
    }
    if (Array.isArray(record)) {
        return record[0] || null;
    }
    return record;
}

function isOutPatient(record) {
    const treatment = normalizeTreatment(record?.treatment);
    return !!treatment && String(treatment.patient_type) === "1";
}

function matchesSearch(item, search) {
    const query = String(search || "").trim().toLowerCase();
    if (!query) {
        return true;
    }

    const haystack = [
        item?.patient?.name,
        item?.patient?.patient_id,
        item?.patient?.telephone,
        item?.diagnosis,
        item?.service_name?.name,
        item?.insurance_service_name?.name,
        item?.service_category?.name,
    ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

    return haystack.includes(query);
}

export const state = {
    outpatients: [],
};

export const getters = {
    outpatients: (state) => state.outpatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.outpatients = newValue;
    },
};

export const actions = {
    async fetchOutPatients({ commit }, params = {}) {
        const page = Math.max(Number(params.page || 1), 1);
        const perPage = Math.max(Number(params.per_page || 10), 1);
        const search = params.search || "";

        const shouldRefresh = params.refresh === true
            || !Array.isArray(outpatientCache)
            || (Date.now() - outpatientCacheFetchedAt) > outpatientCacheTtlMs;

        if (shouldRefresh) {
            const responses = await Promise.all(outpatientEndpoints.map((endpoint) => axios.get(endpoint)));
            const merged = responses
                .flatMap((response) => response.data?.visits || [])
                .filter(isOutPatient);

            outpatientCache = merged.filter((item, index, list) => (
                list.findIndex((entry) => entry.id === item.id) === index
            ));
            outpatientCacheFetchedAt = Date.now();
        }

        const filtered = outpatientCache.filter((item) => matchesSearch(item, search));
        const start = (page - 1) * perPage;
        const paged = filtered.slice(start, start + perPage);

        commit("setPatients", paged);

        return {
            data: {
                treatments: paged,
                pagination: {
                    current_page: page,
                    last_page: Math.max(1, Math.ceil(filtered.length / perPage)),
                    per_page: perPage,
                    total: filtered.length,
                },
            },
        };
    },
};
